import { createAction, props } from '@ngrx/store';

import { Pais } from '@rpe/registro-personas-empresas-lib';
import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';

// LOAD
export const entityPaisesLoadRequest = createAction(
  '[ENTITYPAISES] Load Request'
);

export const entityPaisesLoadFailure = createAction(
  '[ENTITYPAISES] Load Failure',
  props<{ error: Error }>()
);

export const entityPaisesLoadSuccess = createAction(
  '[ENTITYPAISES] Load Success',
  props<{ items: Pais[] }>()
);
